import axios from 'axios'
// eslint-disable-next-line import/no-internal-modules
import tracker from '@insided/deprecated-components/tracker/publish'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'

export interface TeamNoteResponse {
  content: string
  updatedBy: string
  updatedAt: string
}

export async function getTeamNote(topicId: number): Promise<TeamNoteResponse> {
  const { data } = await axios.get(`/teamNote/${topicId}`)
  return data
}

export async function saveTeamNote(topicId: number, content: string): Promise<TeamNoteResponse> {
  const { data } = await axios.post('/teamNote/save', {
    topicId,
    content
  })
  return data
}

export function trackTeamNoteSaved(contentType: string, topicId: number, topicTitle: string, topicUrl: string) {
  const { userid, role, name } = getInsidedData('user')
  tracker.trackEvent('userevent', {
    type: 'Team Note Saved',
    topic_content_type: contentType,
    topic_id: topicId,
    topic_title: topicTitle,
    topic_url: topicUrl,
    saved_by_user_id: userid,
    saved_by_user_primary_role: role,
    saved_by_user_name: name
  })
}
